export const companyMap = {
    'south-china': [
        {
            name: 'Shenzhen Company',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '86-755-33339933',
            fax: '86-755-33958201',
            email: 'kevinsun@cityocean.com',
            location: 'shenzhen-company-address',
        },
        {
            name: 'Guangzhou Branch',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '86-20-38390187',
            fax: '86-20-38390075',
            email: 'paulge@cityocean.com',
            location: 'guangzhou-branch-address',
        },
        {
            name: 'Xiamen Branch',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '86-592-5692528',
            fax: '86-592-5692525',
            email: 'karlxie@cityocean.com',
            location: 'xiamen-branch-address',
        },
        {
            name: 'Pengji Company',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '86-755-33958330',
            fax: '86-755-33958201',
            email: 'kevinsun@cityocean.com',
            location: 'shenzhen-company-address',
        },
    ],
    'east-china': [
        {
            name: 'Shanghai Branch',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '86-021-31319000',
            fax: '86-021-31319022',
            email: 'ldj@cityocean.com',
            location: 'shanghai-branch-address',
        },
        {
            name: 'Ningbo Branch',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '86-574-87640461',
            fax: '86-574-87640460',
            email: 'joannawang@cityocean.com',
            location: 'ningbo-branch-address',
        },
        {
            name: 'Hunan Branch',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '86-731-82296011',
            fax: '86-731-85782406',
            email: 'rickydeng@cityocean.com',
            location: 'hunan-branch-address',
        },
        {
            name: 'Chongqing Office',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '86-23-67756503',
            fax: '',
            email: 'annie@cityocean.com',
            location: 'chongqing-office-address',
        },
        {
            name: 'Wuhan Branch',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '86-027-83520816',
            fax: '',
            email: 'sarafu@cityocean.com',
            location: 'wuhan-office-address',
        },
    ],
    'north-china': [
        {
            name: 'Tianjin Branch',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '86-022-60702491',
            fax: '86-022-60702495',
            email: 'danielsong@cityocean.com',
            location: 'tianjin-branch-address',
        },
        {
            name: 'Qingdao Branch',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '86-0532-66753771',
            fax: '86-0532-66753772',
            email: 'davidchen@cityocean.com',
            location: 'qingdao-branch-address',
        },
        {
            name: 'Dalian Branch',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '86-411-82538564',
            fax: '86-411-82538562',
            email: 'storkgong@cityocean.com',
            location: 'dalian-branch-address',
        },
        {
            name: 'Lianyungang Branch',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '86-0518-81195460',
            fax: '86-0518-81195463',
            email: 'davidchen@cityocean.com',
            location: 'lianyungang-branch-address',
        },
    ],
    'north-america': [
        {
            name: 'New York Branch',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '732-855-1883',
            fax: '732-855-1888',
            email: 'ava@cityocean.net',
            location: '485A Route 1 South, Suite 330 Iselin, NJ 08830',
        },
        {
            name: 'Los Angeles Branch',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '909-569-6968',
            fax: '909-569-6968',
            email: 'may@cityocean.net',
            location: '1350 Valley Vista Drive Diamond Bar, CA 91765',
        },
        {
            name: 'Toronto Branch',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '604-687-6372',
            fax: '604-687-6305',
            email: 'sunny@harvest-logistic.com',
            location: 'Suite 508, 165 Dundas Street West、Mississauga,L5B 2N6 ON',
        },
    ],
    'southeast-asia': [
        {
            name: 'Vietnam Branch',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '84-028-39296333',
            fax: '84-028-39296555',
            email: 'frankzhou@dawuchain.com',
            location: 'ROOM 802 ,8th FLOOR,SGGP BUILDING, 432 - 434 NGUYEN THI MINH KHAI STREET ,WARD 5, DISTRICT 3,HO CHI MINH CITY, VIET NAM',
        },
        {
            name: 'Malaysia Branch',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '732-855-1883',
            fax: '732-855-1888',
            email: 'dephniehon@topshipping.com.my',
            location: 'Unit A-10-03, Garden Shoppe One City, Jalan USJ 25/1F, 4765 Subang Jaya, Selangor, Malaysia.',
        },
        {
            name: 'Indonesia Branch',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '62-812-9389 2466',
            fax: '',
            email: 'leoyang@cityocean.com',
            location: 'MENARA KUNINGAN, JL. HR RASUNA SAID KAV.5 BLOK X-7',
        },
        {
            name: 'Thailand Branch',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '662-163-2866 Ext.404',
            fax: '662-163-2844',
            email: 'barryzhang@cityocean.com',
            location: '98 Sathorn Square Office Tower，20th floor,Unit No.2009-2010,North Sathorn Road Khwaeng Silom Bang Rak,Bangkok,Thailand',
        },
    ],
    cbec: [
        {
            name: 'Ningbo Company',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '86-574-87640461',
            fax: '86-574-87640460',
            email: 'adaxu@cityocean.com',
            location: 'ningbo-company-address',
        },
        {
            name: 'Shanghai Branch',
            img: 'images/backgrounds/two-cols-description-bg.jpg',
            phone: '86-021-60396188',
            fax: '86-021-60396171',
            email: 'adaxu@cityocean.com',
            location: 'shanghai-branch-address',
        },
    ],
}

export const historyList = [
    {
        year: '2019',
        content: 'about-year-2019',
    },
    {
        year: '2017',
        content: 'about-year-2017',
    },
    {
        year: '2016',
        content: 'about-year-2016',
    },
    {
        year: '2013',
        content: 'about-year-2013',
    },
    {
        year: '2010',
        content: 'about-year-2010',
    },
    {
        year: '2009',
        content: 'about-year-2009',
    },
    {
        year: '2008',
        content: 'about-year-2008',
    },
    {
        year: '2007',
        content: 'about-year-2007',
    },
    {
        year: '2005',
        content: 'about-year-2005',
    },
    {
        year: '2003',
        content: 'about-year-2003',
    },
    {
        year: '2002',
        content: 'about-year-2002',
    },
    {
        year: '2001',
        content: 'about-year-2001',
    },
    {
        year: '2000',
        content: 'about-year-2000',
    },
    {
        year: '1998',
        content: 'about-year-1998',
    },
].reverse()

export const socialRecruitments = [
    {
        prefix: `job-international-shipping-sales-`,
        title: '国际海运拓展专员',
        responsibilities: `1、负责承揽国际海运业务，准确把握市场动态和客户需求；
2、依托公司良好的资源和实力优势开发新的同行市场；
3、为客户提供优质的物流服务。`,
        requirements: `1、热爱销售，良好的英语读写基础； 
2、性格开朗，学习和沟通能力强；
3、积极进取，责任心强，良好的团队合作精神。`,
        titleEN: 'International shipping sales',
        responsibilitiesEN: `1. Responsible for contracting international shipping business, accurately grasping market trends and customer demands;
2. Develop new peer markets based on the company's good resources and strength;
3. Provide customers with quality logistics services.
`,
        requirementsEN: `1. Love sales, good English reading and writing foundation; 
2. Cheerful personality, strong learning and communication skills;
3. Aggressive, responsible and good team work spirit.
`,
    },
    {
        prefix: `job-commissioner-of-international-maritime-market-`,
        title: '国际海运市场专员',
        responsibilities: `1、 依托公司资源和实力通过电话、网络、展会等方式开发外贸公司、工厂类客户；
2、 维护老客户，分析整理潜在客户，建立良好的长期合作关系；
3、 为不同的客户量身制订专属的物流方案、提供优质的物流服务。`,
        requirements: `1、大专以上学历，英文电函读、写熟练；
2、热爱物流销售工作，经验不限；
3、责任心强，学习能力强，良好的团队合作精神。`,
    },
    {
        prefix: `job-overseas-business-development-specialist-`,
        title: '海外业务拓展专员',
        responsibilities: `1、通过邮件、电话、展会、社交软件等渠道开发海外代理；
2、准确把握客户需求，为客户提供最佳物流解决方案；
3、与海外客户建立良好的长期合作关系。`,
        requirements: `1、英文电函读写能力强，口语沟通良好；
2、对海外业务有极大的热忱，吃苦耐劳，有毅力；
3、良好的沟通能力、敏锐的市场反应能力。`,
    },
    {
        prefix: `job-cross-border-e-commerce-business-specialist-`,
        title: '跨境电商业务专员',
        responsibilities: `1、依托公司良好的资源和实力优势开发潜在电商物流客户；
2、熟悉FBA业务流程，熟悉海卡、海派、空派的渠道流程；
3、与客户建立良好的长期合作关系。
`,
        requirements: `1、大专以上学历 ，有一定的英语读写基础；
2、热爱销售工作，性格开朗，沟通能力强；
3、积极进取，责任心强，良好的团队合作精神。
`,
    },
    {
        prefix: `job-international-shipping-operations-`,
        title: '国际海运操作专员',
        responsibilities: `1、负责订舱、客服、拖车、报关等海运操作服务；
2、负责海运单证及文件的制作、整理、归档工作；
3、与船公司及客户保持良好的合作关系。
`,
        requirements: `1、负责订舱、客服、拖车、报关等海运操作服务；
2、负责海运单证及文件的制作、整理、归档工作；
3、与船公司及客户保持良好的合作关系。
`,
    },
    {
        prefix: `job-software-development-engineer-`,
        title: '软件开发工程师',
        responsibilities: `1、负责公司H5，Web、微信公众号等产品的分析设计、开发实现和持续改善，优化应用程序及网站前端性能；
2、参与公司各业务系统的分析和解耦设计，开发与维护网站架构中的底层核心模块；
3、编写高质量的前端代码。
`,
        requirements: `1、3年以上web前端开发工作经验；
2、精通HTML5/JavaScript/CSS3等Web开发技术；
3、精通前端MVVM框架Angular及相关技术(RXJS,LESS/SASS)；
4、精通前端构建工具Webpack。
`,
    },
]

export const campusRecruitments = [

]

export const salesPersons = [
    {
        cnName: `曾河西`,
        enName: `JELLO`,
        company: `Guangzhou Branch`,
        job: `sales-zhx-job`,
        entryTime: `2010`,
        desc: `sales-zhx-desc`,
        motto: `sales-zhx-motto`,
        img: `images/contactus/p-zhx.png`,
        imgLg: `images/contactus/p-zhx-lg.png`,
    },
    {
        cnName: `常志强`,
        enName: `NICK`,
        company: `Shanghai Branch`,
        job: `sales-czq-job`,
        entryTime: `2010`,
        desc: `sales-czq-desc`,
        motto: `sales-czq-motto`,
        img: `images/contactus/p-czq.png`,
        imgLg: `images/contactus/p-czq-lg.png`,
    },
    {
        cnName: `王青`,
        enName: `Alisa`,
        company: `Tianjin Branch`,
        job: `sales-wq-job`,
        entryTime: `2018`,
        desc: `sales-wq-desc`,
        motto: `sales-wq-motto`,
        img: `images/contactus/p-wq.png`,
        imgLg: `images/contactus/p-wq-lg.png`,
    },
    // {
    //     cnName: `徐飞`,
    //     enName: `Iven`,
    //     company: `Shenzhen company`,
    //     job: `sales-xf-job`,
    //     entryTime: `2011`,
    //     desc: `sales-xf-desc`,
    //     motto: `sales-xf-motto`,
    //     img: `images/contactus/p-xf.png`,
    //     imgLg: `images/contactus/p-xf-lg.png`,
    // },
    {
        cnName: `邓成铁`,
        enName: `Ricky`,
        company: `Hunan Branch`,
        job: `sales-dct-job`,
        entryTime: `2008`,
        desc: `sales-dct-desc`,
        motto: `sales-dct-motto`,
        img: `images/contactus/p-dct.png`,
        imgLg: `images/contactus/p-dct-lg.png`,
    },
    {
        cnName: `张辉`,
        enName: `Justin`,
        company: `COLA`,
        job: `sales-zh-job`,
        entryTime: `2009`,
        desc: `sales-zh-desc`,
        motto: `sales-zh-motto`,
        img: `images/contactus/p-zh.png`,
        imgLg: `images/contactus/p-zh-lg.png`,
    },
    // {
    //     cnName: ``,
    //     enName: ``,
    //     company: ``,
    //     job: ``,
    //     entryTime: ``,
    //     desc: ``,
    //     motto: ``,
    //     img: `images/contactus/p-.png`,
    //     imgLg: `images/contactus/p--lg.png`,
    // },
]